import { render } from "./responderAsPerguntas.vue?vue&type=template&id=886a6b0a&scoped=true"
import script from "./responderAsPerguntas.vue?vue&type=script&lang=js"
export * from "./responderAsPerguntas.vue?vue&type=script&lang=js"

import "./responderAsPerguntas.vue?vue&type=style&index=0&id=886a6b0a&lang=scss&scoped=true"
import "./responderAsPerguntas.vue?vue&type=style&index=1&id=886a6b0a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-886a6b0a"]])

export default __exports__